// crewbit-admin/src/components/money/bootstrap/BootstrapWizardCard.tsx
//
// Tier 2-UI Phase A §WorldClass.4 — Settings hub re-entry card. Mounted
// above the SettingsLandingMenu on /money/settings landing.
//
// Per Decision §A.D5: owner-only (caller already gates), visible regardless
// of bootstrap-already-run state, pill state derives from
// businesses.activity_class IS NOT NULL proxy.

import { ChevronRight, Sparkles } from 'lucide-react';
import { admin, palette, radii, spacing } from '../../../styles/tokens';
import SettingsStatusPill from '../settings/SettingsStatusPill';

interface Props {
  hasRun: boolean;
  onClick: () => void;
}

export default function BootstrapWizardCard({ hasRun, onClick }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: spacing.md,
        background: palette.white,
        border: `1px solid ${admin.border}`,
        borderRadius: admin.cardRadius,
        padding: spacing.md,
        textAlign: 'left',
        cursor: 'pointer',
        fontFamily: 'inherit',
        width: '100%',
      }}
    >
      <div
        style={{
          width: 40,
          height: 40,
          borderRadius: radii.md,
          background: palette.accentWash,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <Sparkles size={20} color={palette.accent} />
      </div>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: spacing.xs }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: spacing.sm,
          }}
        >
          <div style={{ fontSize: 14, fontWeight: 600, color: palette.g800 }}>
            Run setup wizard
          </div>
          <SettingsStatusPill
            kind={hasRun ? 'active' : 'invite'}
            label={hasRun ? 'Configured' : 'Set up'}
          />
        </div>
        <div style={{ fontSize: 12, color: palette.g500 }}>
          {hasRun
            ? 'Defaults are set up. Run again to refresh — your customizations are preserved.'
            : 'Smart defaults you can apply once instead of typing them every time. Adds HST rate, mileage rates, payment terms, and more based on your province and trade.'}
        </div>
      </div>
      <ChevronRight size={18} color={palette.g500} />
    </button>
  );
}
